/* eslint-disable react/display-name */
import React, { ReactElement, useCallback } from 'react';
import { log } from '@24i/nxg-core-utils/src/logger';
import {
    getTelegramWebApp,
    isTelegramKVersion,
    isTelegramAVersion,
    isWebView,
} from '@24i/nxg-sdk-higgs/src/utils';
import useNavigation from '@24i/nxg-core-router/src/hooks/useNavigation';

import View from './View';
import { useViewModel } from './viewModel';
import { GenreScreenProps, GenreViewModelProps } from './types';
import { WithWebHeaderProps } from '../../navigation/components/withWebHeader/types';

const Main = (props: GenreScreenProps): ReactElement => {
    const viewModelProps: GenreViewModelProps = useViewModel(props);
    const { goBack } = useNavigation();

    const handleBack = useCallback(() => {
        log('[GenreScreen] Back navigation triggered');
        goBack();
    }, []);

    const isTelegramK = isTelegramKVersion();
    const TelegramWebApp = getTelegramWebApp();
    const isFullscreen = TelegramWebApp?.isFullscreen;
    const selectedGenre = Array.isArray(viewModelProps.selectedGenre)
        ? viewModelProps.selectedGenre.join(', ')
        : viewModelProps.selectedGenre;

    // Use the same pattern as DetailsScreen for consistent behavior
    const webHeaderProps: WithWebHeaderProps = {
        fullWidth: true,
        hasMargin: false,
        noVerticalMargin: true,
        webHeaderTitle: 'Genres',
        // CRITICAL: Never force disable for Telegram K, as that would prevent back button setup
        forceDisable: !isWebView() && !isTelegramKVersion() && !isTelegramAVersion(),
        // Always use the native back button mechanism for Telegram
        backButtonTitle: selectedGenre,
        // For Telegram in fullscreen mode, show sticky header
        variant: 'sticky',
        // Add a custom flag to identify Telegram non-fullscreen case
        isTelegramNonFullscreen: isTelegramK && !isFullscreen,
        // Pass the back handler
        onBackPressOverride: handleBack,
    };

    // For non-web platforms, return the regular view
    return <View {...viewModelProps} {...webHeaderProps} />;
};

export default {
    Main,
    useViewModel,
    View,
};
